import { IncomingMessage } from 'http';

import { fechFromBPartsApi } from '../utils';

const fetchLastEntries = async (
  {
    locale,
    carIdentifier,
    partIdentifier,
    detailed_prices = false,
  }: {
    locale: string;
    partIdentifier?: string;
    carIdentifier: string;
    detailed_prices?: boolean;
  },
  req?: IncomingMessage
): Promise<Array<TProductListItem> | null> => {
  const query = [];
  if (carIdentifier) {
    query.push(`car_identifier=${encodeURI(carIdentifier)}`);
  }
  if (partIdentifier) {
    query.push(`part_identifier=${encodeURI(partIdentifier)}`);
  }

  if (detailed_prices) {
    query.push(`detailed_prices=${detailed_prices}`);
  }

  return fechFromBPartsApi(
    `/${locale}/shop/products/last_entries?${query.join('&')}`,
    {
      headers: req ? new Headers(req.headers as HeadersInit) : undefined,
      credentials: 'include',
    },
    { enableCustomErrorWrapper: true }
  );
};

export default fetchLastEntries;
